export const PLACEHOLDER_ITEMS = [
  {
    description: "This is item 1's description",
    price: {
      amount: 12000,
      currency: 'GBP',
    },
    quantity: 1000,
    style: 'kanda',
    title: 'Item 1',
    vat: {
      amount: 24000,
      currency: 'GBP',
    },
    vat_rate: '20%',
    key: 'placeholder-0',
  },
  {
    description: "This is item 2's description",
    price: {
      amount: 12000,
      currency: 'GBP',
    },
    quantity: 1000,
    style: 'kanda',
    title: 'Item 2',
    vat: {
      amount: 24000,
      currency: 'GBP',
    },
    vat_rate: '20%',
    key: 'placeholder-1',
  },
];
